import React from "react";
import PropTypes from "prop-types";
import { isBlackFridayActive } from "../../../config/blackFridayConfig";
import BFBackground from "../../../icons/BF2025/BFBackground.svg";
import Footer from "../Footer";
import LoginHighlights from "./LoginHighlights";
import LoginVisual from "./LoginVisual";

import * as styles from "./styles.module.scss";

/**
 * The layout used for the login, signup and password reset pages: a full-height bar on the left.
 *
 * Render one instance around several routes to keep the bar mounted while navigating between them.
 *
 * @param {Object}       props               The props.
 * @param {ReactElement} props.children      The page content.
 * @param {ReactElement} props.visualContent Content shown on top of the animated background, right of the bar; not
 *                                           shown during Black Friday, which has no animated background.
 *
 * @returns {ReactElement} The login layout.
 */
const LoginLayout = ( { children, visualContent = <LoginHighlights /> } ) => {
	const isBF        = isBlackFridayActive();
	const layoutClass = isBF ? styles.layoutLoginBF : styles.layoutLogin;

	// I was having some issues importing the SVG background image in the css file. This appeared to work.
	const layoutStyle = isBF ? {
		backgroundImage: `url(${ BFBackground })`,
		backgroundSize: "cover",
		backgroundPosition: "center",
		backgroundRepeat: "no-repeat",
	} : {};

	return (
		<div className={ layoutClass } style={ layoutStyle }>
			<div className={ styles.bar }>
				<div className={ styles.content }>
					{ children }
				</div>
				<Footer variant="light" />
			</div>
			<LoginVisual withBackground={ ! isBF }>
				{ isBF ? null : visualContent }
			</LoginVisual>
		</div>
	);
};

LoginLayout.propTypes = {
	children: PropTypes.node.isRequired,
	visualContent: PropTypes.node,
};

export default LoginLayout;
